module.exports = __webpack_public_path__ + "img/attachment.76a1c740.png";